import React from 'react';
import DashBoard from './DashBoard';
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/css/bootstrap.min.css";
const JuryPortal: React.FC = () => {

  return (
    <>
    <DashBoard />
     </>
  );
};

export default JuryPortal;
